/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Masl_PlaceholderInputs */

const en_masl_placeholder = /** @type {(inputs: Masl_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. 1800`)
};

const es_masl_placeholder = /** @type {(inputs: Masl_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. 1800`)
};

/**
* | output |
* | --- |
* | "e.g. 1800" |
*
* @param {Masl_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const masl_placeholder = /** @type {((inputs?: Masl_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Masl_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_masl_placeholder(inputs)
	return es_masl_placeholder(inputs)
});